import React from 'react';
import PropTypes from 'prop-types';
import SessionManagerContext from './SessionManagerContext';
import SessionManager from '@afosto/auth/SessionManager';

/**
 * Session manager provider
 * @param {Object} props
 * @returns {function}
 * @constructor
 */
const SessionManagerProvider = (props = {}) => {
  const { children } = props;

  return (
    <SessionManagerContext.Provider value={SessionManager}>
      {children}
    </SessionManagerContext.Provider>
  );
};

SessionManagerProvider.defaultProps = {
  children: null,
};

SessionManagerProvider.propTypes = {
  children: PropTypes.node,
};

export default SessionManagerProvider;
